import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import { allEnumValues } from "./helper.js";
import { LanguageCode } from "./language_code.js";
//#region src/language_code_helper.ts
var language_code_helper_exports = /* @__PURE__ */ __exportAll({
	isRtl: () => isRtl,
	localizedName: () => localizedName,
	name: () => name,
	supplementLanguages: () => supplementLanguages
});
function name(languageCode) {
	switch (languageCode) {
		case "en-us": return "English (US)";
		case "ar-sa": return "Arabic (SA)";
		case "en-gb": return "English (UK)";
		case "fr-ca": return "French (CA)";
		case "es-us": return "Spanish (US)";
		case "zh-cn": return "Chinese (Simplified)";
		case "ja-jp": return "Japanese";
		case "ko-kr": return "Korean";
		case "pt-br": return "Portuguese (Brazil)";
		case "vi-vn": return "Vietnamese";
		case "de-de": return "German";
		case "it-it": return "Italian";
	}
}
function localizedName(languageCode) {
	switch (languageCode) {
		case "en-us": return "English";
		case "ar-sa": return "العربية";
		case "en-gb": return "English";
		case "fr-ca": return "Français";
		case "es-us": return "Español";
		case "zh-cn": return "中文";
		case "ja-jp": return "日本語";
		case "ko-kr": return "한국어";
		case "pt-br": return "Português";
		case "vi-vn": return "Tiếng Việt";
		case "de-de": return "Deutsch";
		case "it-it": return "Italiano";
	}
}
function supplementLanguages() {
	return allEnumValues(LanguageCode).filter((languageCode) => {
		return languageCode !== "en-us";
	});
}
const rtlLanguageCodeSet = /* @__PURE__ */ new Set(["ar-sa"]);
function isRtl(languageCode) {
	return rtlLanguageCodeSet.has(languageCode);
}
//#endregion
export { isRtl, language_code_helper_exports, localizedName, name, supplementLanguages };

//# sourceMappingURL=language_code_helper.js.map